/**
 * pdf.js has no support for ShadingType 1 (function-based) gradients and falls back to
 * painting them with a hardcoded literal color: `DummyShadingPattern.getPattern()` returns
 * "hotpink" (see pdfjs-dist's display/pattern_helper). PDFs exported with this shading type
 * (e.g. from some design tools) then render with a bright pink overlay that doesn't exist in
 * the source document. Since pdf.js exposes no public API to override this fallback, and no
 * legitimate part of this app draws canvas fills with the literal color "hotpink", we
 * intercept it globally and render nothing instead of an incorrect pink block.
 */
let patched = false;

export function patchPdfShadingFallback(): void {
  if (patched || typeof CanvasRenderingContext2D === 'undefined') return;
  patched = true;

  const descriptor = Object.getOwnPropertyDescriptor(
    CanvasRenderingContext2D.prototype,
    'fillStyle',
  );
  const nativeSetter = descriptor?.set;
  const nativeGetter = descriptor?.get;
  if (!nativeSetter || !nativeGetter) return;

  Object.defineProperty(CanvasRenderingContext2D.prototype, 'fillStyle', {
    configurable: true,
    enumerable: descriptor.enumerable,
    get(this: CanvasRenderingContext2D) {
      return nativeGetter.call(this);
    },
    set(this: CanvasRenderingContext2D, value: string | CanvasGradient | CanvasPattern) {
      if (typeof value === 'string' && value.toLowerCase() === 'hotpink') {
        nativeSetter.call(this, 'transparent');
        return;
      }
      nativeSetter.call(this, value);
    },
  });
}
